import React, { useState } from 'react';
import { ComparisonChart } from '../../../components/social/ComparisonChart';

export default function ComparacaoPage() {
  const [selectedFriend, setSelectedFriend] = useState<string | null>('1');

  // Mock de amigos
  const friends = [
    {
      id: '1',
      name: 'Maria Silva',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20avatar%20portrait%20simple%20background%20friendly%20smile&width=100&height=100&seq=compare-001&orientation=squarish',
      level: 15,
      xp: 12500,
      badges: 8,
      missions: 24,
      rank: 5
    },
    {
      id: '2',
      name: 'João Santos',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20avatar%20portrait%20simple%20background%20confident&width=100&height=100&seq=compare-002&orientation=squarish',
      level: 18,
      xp: 15800,
      badges: 12,
      missions: 32,
      rank: 3
    },
    {
      id: '3',
      name: 'Ana Costa',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20avatar%20portrait%20simple%20background%20warm%20smile&width=100&height=100&seq=compare-003&orientation=squarish',
      level: 22,
      xp: 22000,
      badges: 15,
      missions: 45,
      rank: 1
    }
  ];

  const currentUser = {
    name: 'Você',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20person%20avatar%20portrait%20simple%20background%20friendly%20smile&width=100&height=100&seq=current-user-001&orientation=squarish',
    level: 12,
    xp: 9800,
    badges: 6,
    missions: 18,
    rank: 8
  };

  const selectedFriendData = friends.find((f) => f.id === selectedFriend);

  const comparisonData = selectedFriendData
    ? {
        you: currentUser,
        friend: selectedFriendData
      }
    : null;

  return (
    <div className="space-y-6 pb-20 lg:pb-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Comparar Progresso
        </h1>
        <p className="text-gray-600">
          Compare seu desempenho com seus amigos e veja onde você pode melhorar!
        </p>
      </div>

      {/* Seletor de Amigo */}
      <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
        <label className="block text-sm font-semibold text-gray-700 mb-3">
          Selecione um amigo para comparar
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {friends.map((friend) => (
            <button
              key={friend.id}
              onClick={() => setSelectedFriend(friend.id)}
              className={`flex items-center gap-3 p-4 rounded-lg border-2 transition-all ${
                selectedFriend === friend.id
                  ? 'border-teal-500 bg-teal-50'
                  : 'border-gray-200 hover:border-teal-300 hover:bg-gray-50'
              }`}
            >
              <img
                src={friend.avatar}
                alt={friend.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div className="text-left">
                <p className="font-semibold text-gray-800">{friend.name}</p>
                <p className="text-sm text-gray-600">Nível {friend.level}</p>
              </div>
              {selectedFriend === friend.id && (
                <i className="ri-check-line text-2xl text-teal-500 ml-auto"></i>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Gráfico de Comparação */}
      {comparisonData && <ComparisonChart data={comparisonData} />}

      {/* Desafios Sugeridos */}
      <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
            <i className="ri-sword-line text-2xl text-white"></i>
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-800">Desafios Amigáveis</h3>
            <p className="text-sm text-gray-600">Desafie seus amigos e ganhe XP extra!</p>
          </div>
        </div>

        <div className="grid gap-3">
          <div className="flex items-center justify-between p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg border-2 border-purple-200">
            <div className="flex items-center gap-3">
              <i className="ri-trophy-line text-2xl text-purple-600"></i>
              <div>
                <p className="font-semibold text-gray-800">Corrida de XP</p>
                <p className="text-sm text-gray-600">Quem ganha mais XP em 7 dias?</p>
              </div>
            </div>
            <button className="px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg font-medium hover:from-purple-600 hover:to-pink-600 transition-all whitespace-nowrap">
              Desafiar
            </button>
          </div>

          <div className="flex items-center justify-between p-4 bg-gradient-to-r from-green-50 to-teal-50 rounded-lg border-2 border-green-200">
            <div className="flex items-center gap-3">
              <i className="ri-flag-line text-2xl text-green-600"></i>
              <div>
                <p className="font-semibold text-gray-800">Maratona de Missões</p>
                <p className="text-sm text-gray-600">Quem completa mais missões?</p>
              </div>
            </div>
            <button className="px-4 py-2 bg-gradient-to-r from-green-500 to-teal-500 text-white rounded-lg font-medium hover:from-green-600 hover:to-teal-600 transition-all whitespace-nowrap">
              Desafiar
            </button>
          </div>

          <div className="flex items-center justify-between p-4 bg-gradient-to-r from-orange-50 to-yellow-50 rounded-lg border-2 border-orange-200">
            <div className="flex items-center gap-3">
              <i className="ri-medal-line text-2xl text-orange-600"></i>
              <div>
                <p className="font-semibold text-gray-800">Caça aos Distintivos</p>
                <p className="text-sm text-gray-600">Quem desbloqueia mais distintivos?</p>
              </div>
            </div>
            <button className="px-4 py-2 bg-gradient-to-r from-orange-500 to-yellow-500 text-white rounded-lg font-medium hover:from-orange-600 hover:to-yellow-600 transition-all whitespace-nowrap">
              Desafiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
